import React, { useId } from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormHelperText,
  IconButton,
  Tooltip,
} from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import { Controller, type Control } from "react-hook-form";
import { type BulkAcquireFormData } from "../utils/bulkAcquireFormSchema";

/**
 * 「未取得の登記・図面のみを取得」。ONの間は自身の取得済みのセルを選べなくする指定で、
 * 「取得条件」の枠の中で、取得方法・経過日数と同じ行に並べる
 */
export const BulkExcludeAcquiredCheckbox: React.FC<{
  control: Control<BulkAcquireFormData>;
  /** 指定を受け付けない条件（自社取得済みを使う取得方法）では非活性にして理由を添える */
  locked: boolean;
}> = ({ control, locked }) => {
  const noteId = useId();
  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <Controller
          name="excludeAcquired"
          control={control}
          render={({ field: { value, onChange } }) => (
            <FormControlLabel
              sx={{ mr: 0 }}
              control={
                <Checkbox
                  checked={value}
                  onChange={(event) => {
                    onChange(event.target.checked);
                  }}
                  disabled={locked}
                  inputProps={{
                    "aria-describedby": locked ? noteId : undefined,
                  }}
                />
              }
              label="未取得の登記・図面のみを取得"
            />
          )}
        />
        <Tooltip
          // title が要素だと開いている間ボタン名が本文に置き換わるため、説明として紐づける
          describeChild
          title={
            <span style={{ whiteSpace: "pre-line" }}>
              {"ONの間は取得済みのセルを選択できなくなります\n" +
                "全部事項は目録の組み合わせに関わらず、いずれかを取得済みなら4列とも選択できません"}
            </span>
          }
        >
          <IconButton
            size="small"
            aria-label="未取得のみの指定の説明"
            // 日本語の字面は行の中央よりやや上に見えるため、目視でそろう位置まで上げる
            sx={{ p: 0, position: "relative", top: -1 }}
          >
            <HelpIcon />
          </IconButton>
        </Tooltip>
      </Box>
      {locked && (
        <FormHelperText id={noteId} sx={{ mt: 0 }}>
          自社取得済み登記を使う取得方法では指定できません
        </FormHelperText>
      )}
    </Box>
  );
};
